// extracted by mini-css-extract-plugin
export default {"pagesControlsContainer":"MyOrders-module__pagesControlsContainer--FERWg","pageControlBtn":"MyOrders-module__pageControlBtn--FhWNd","orders":"MyOrders-module__orders--eCsHy"};